import { render, staticRenderFns } from "./EditorToolbar.vue?vue&type=template&id=c54931c0&scoped=true&"
import script from "./EditorToolbar.vue?vue&type=script&lang=js&"
export * from "./EditorToolbar.vue?vue&type=script&lang=js&"
import style0 from "./EditorToolbar.vue?vue&type=style&index=0&id=c54931c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54931c0",
  null
  
)

export default component.exports